/**
 * Logo da ticketeira compilada.
 *
 * Existe como componente por causa da placa: os PNGs entregues não servem nos
 * dois temas. O da All Ingressos é branco com fundo transparente e desaparece
 * sobre o branco do tema dia; o da LM Duo é opaco com fundo branco e vira um
 * retângulo claro no tema noite. Qual placa usar em cada modo é cadastro do
 * flavor (`placaLogo`), não decisão desta tela.
 */

import React from 'react';
import {Image, View} from 'react-native';

import {useTema} from './tema';

export function Marca({largura = 132}: {largura?: number}) {
  const t = useTema();

  const imagem = (
    <Image
      source={t.logo}
      resizeMode="contain"
      accessibilityLabel={t.empresa}
      style={{width: largura, height: largura}}
    />
  );

  if (!t.placaLogo) {
    return imagem;
  }

  return (
    <View
      style={{
        alignSelf: 'flex-start',
        backgroundColor: t.placaLogo,
        borderRadius: 16,
        padding: 12,
      }}>
      {imagem}
    </View>
  );
}
